const Marquee = ({ items, slow = false, dark = true }) => {
  const row = (ariaHidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span
            className={`font-display font-extrabold tracking-tight text-2xl md:text-4xl px-6 md:px-10 whitespace-nowrap ${
              dark ? "text-mist/90" : "text-navy/90"
            }`}
          >
            {item}
          </span>
          <span className="w-2 h-2 rounded-full bg-electric shrink-0" />
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden py-8 md:py-10 border-y ${
        dark ? "border-white/5 bg-navy" : "border-navy/5 bg-mist"
      }`}
    >
      <div className={`flex w-max ${slow ? "animate-marquee-slow" : "animate-marquee"}`}>
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
};

export default Marquee;
